module.exports = __webpack_public_path__ + "img/TCL-icon.dc47e2e6.png";